import { RadioTypes } from "../commonTypes/universalTypes";

export const JOB_TYPE_OPTIONS: RadioTypes[] = [
  {
    id: "OneTimeJob",
    name: "One Time Job",
  },
  {
    id: "RecurringJob",
    name: "Recurring Job",
  },
];

export const JOB_STATUS_OPTIONS = [
  { label: "Not Yet In", value: "notYetIn" },
  { label: "Pending", value: "pending" },
  { label: "Open Items Sent", value: "openItemsSent" },
  { label: "Open Items Received", value: "openItemsReceived" },
  { label: "Allocated", value: "Allocated" },
  { label: "Active", value: "Active" },
];

export const REPEAT_JOB_OPTIONS = [
  { value: "Monthly", label: "Monthly" },
  { value: "Yearly", label: "Yearly" },
  { value: "Weekly", label: "Weekly" },
  { value: "Daily", label: "Days" },
];

export const WAIT_POST_PERIOD_START_DATE = [
  // { value: "None", label: "None" },
  { value: "Days", label: "Days After Periods Ends" },
  { value: "Weeks", label: "Weeks After Period Ends" },
  { value: "Months", label: "Months After Period Ends" },
];

export const WAIT_POST_PERIOD_START_DATE_START_OF_PERIOD = [
  // { value: "None", label: "None" },
  { value: "Days", label: "Days After Periods Starts" },
  { value: "Weeks", label: "Weeks After Period Starts" },
  { value: "Months", label: "Months After Period Starts" },
];

export const WAIT_POST_PERIOD_END_DATE = [
  { value: "Days", label: "Days After Period Ends" },
  { value: "Weeks", label: "Weeks After Period Ends" },
  { value: "Months", label: "Months After Period Ends" },
  // { value: "End Of Aa Month", label: "End Of AA Month" }
];

export const CREATE_JOB_ON = [
  { value: "Start of Period", label: "Start Of Period" },
  { value: "End of Period", label: "End Of Period" },
];

export const JOBS_PRIORITY = [
  { value: "normal", label: "normal" },
  { value: "red", label: "red" },
  { value: "blue", label: "blue" },
  { value: "green", label: "green" },
];

export const periodOption: any = () => {
  let data = [];
  for (let i = 1; i <= 31; i++) {
    let obj: any = {};
    obj.label = i.toString();
    obj.value = i.toString();
    data.push(obj);
  }
  return data;
};

export const JOB_CHECKLIST_HEADER = [
  { label: "Title", value: "title", width: "700px" },
  { label: "Created / Updated by", value: "updated_by" },
  { label: "Action", value: "action" },
];

export const STATUS_OF_PROCEDURE=[
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Not Applicable",
    value: "not applicable",
  }
];
